import { useEffect, useRef, useState } from "react";
import { Eraser } from "@phosphor-icons/react";

// Finger/stylus/mouse signature capture. onChange(dataUrl | "") fires after every stroke.
export function SignaturePad({ onChange, height = 160, testid = "signature-pad" }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const w = c.parentElement.clientWidth;
    c.width = w * ratio; c.height = height * ratio;
    c.style.width = `${w}px`; c.style.height = `${height}px`;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#1A2744";
  }, [height]);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(p.x + 0.1, p.y + 0.1); ctx.stroke(); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); };
  const end = () => { if (!drawing.current) return; drawing.current = false; setEmpty(false); onChange?.(canvasRef.current.toDataURL("image/png")); };
  const clear = () => { const c = canvasRef.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange?.(""); };

  return (
    <div className="relative rounded-xl border bg-white" style={{ borderColor: empty ? "var(--bk-border)" : "var(--bk-success)" }} data-testid={testid}>
      <canvas ref={canvasRef} className="block touch-none rounded-xl cursor-crosshair" data-testid={`${testid}-canvas`}
        onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} onPointerCancel={end} />
      {empty && <p className="absolute inset-x-0 bottom-3 text-center text-xs pointer-events-none" style={{ color: "var(--bk-text-2)" }}>Sign here with your finger, stylus or mouse</p>}
      <div className="absolute left-4 right-4 bottom-9 border-b border-dashed pointer-events-none" style={{ borderColor: "#CBD5E1" }} />
      <button type="button" onClick={clear} data-testid={`${testid}-clear`} className="absolute top-2 right-2 inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full border bg-white" style={{ borderColor: "var(--bk-border)", color: "var(--bk-text-2)" }}>
        <Eraser size={12} weight="bold" /> Clear
      </button>
    </div>
  );
}
